import { LoadOptions, Value } from 'app/types-shared';
import { ExperienceTransferTranslation } from '../constants';
import {
  ExperienceTransferFormState, ExperienceTransferItem, ExperienceTransferItemValidation
} from './types-store';
import { FilterOption } from 'app/components/options-handler/types';

export interface ExperienceTransferItemWire {
  id: number;
  active: boolean;
  criteria?: Value;
  caseType?: Value;
  operation?: Value;
  subscriberGroup?: SubscriberGroupValue;
}

export interface SubscriberGroupValue extends Value {
  disabled?: string;
}

export interface ExperienceTransferDetailsContainerProps {
  actionType: ExperienceTransferActionType;
  experienceTransferItem: ExperienceTransferItem;
  locale: string;
  translation: ExperienceTransferTranslation;
  fetching?: boolean;
  validation: ExperienceTransferItemValidation;
  options?: { [key: string]: FilterOption };
  loadOptions: (
    id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  updateItem: (item: Partial<ExperienceTransferItem>) => void;
  displayError: (errorMessage: string) => void;
  resetValidation: (id: number, key?: string) => void;
  clearValidation: () => void;
}

export interface ExperienceTransferContainerProps {
  actionType: ExperienceTransferActionType;
  formState: ExperienceTransferFormState;
  shouldPrompt: boolean;
  validation: ExperienceTransferItemValidation;
  translation: ExperienceTransferTranslation;
  children?: React.ReactNode;
  saveExperienceTransfer: (experienceTransfer: ExperienceTransferItem) => void;
  deleteExperienceTransfer: () => void;
  updateValidation: (validation: ExperienceTransferItemValidation) => void;
  displayError: (errorMessage: string) => void;
}

export interface ExperienceTransferFormProps {
  actionType?: ExperienceTransferActionType;
  formState: ExperienceTransferFormState;
  shouldPrompt: boolean;
  options?: { [key: string]: FilterOption };
  locale: string;
  translation: ExperienceTransferTranslation;
  loadOptions: (
    id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  saveExperienceTransfer: (item: ExperienceTransferItem) => void;
  deleteExperienceTransfer: () => void;
  updateItem: (item: Partial<ExperienceTransferItem>) => void;
  updateValidation: (validation: ExperienceTransferItemValidation) => void;
  displayError: (errorMessage: string) => void;
  resetValidation: (id: number, key?: string) => void;
  clearValidation: () => void;
}

export interface ExperienceTransferStickyHeaderProps {
  actionType: ExperienceTransferActionType;
  shouldPrompt: boolean;
  experienceTransferItem: ExperienceTransferItem;
  name: string;
  fetching: boolean;
  translation: ExperienceTransferTranslation;
  displayError: (errorMessage: string) => void;
  onSave: () => void;
  onDelete: () => void;
}

export enum ExperienceTransferActionType {
  add = 'add',
  edit = 'edit'
}
